'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Close } from '@eqi-investimentos/icons/web';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Portal } from '@chakra-ui/react';
import { PATHS } from '@/config/paths';
import { Thumb } from '@/components/atoms/Thumb';
export const ModalUnauthenticated = () => {
  const [isOpened, setIsOpened] = useState(false);
  const {
    t
  } = useTranslation(`common`);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener(`close-unauthenticated-modal`, handleClose);
      window.addEventListener(`open-unauthenticated-modal`, handleOpen);
      return () => {
        window.removeEventListener(`close-unauthenticated-modal`, handleClose);
        window.removeEventListener(`open-unauthenticated-modal`, handleOpen);
      };
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOpen = () => {
    setIsOpened(true);
  };
  const handleClose = () => {
    setIsOpened(false);
  };
  if (!isOpened) return <></>;
  return <Portal data-sentry-element="Portal" data-sentry-component="ModalUnauthenticated" data-sentry-source-file="index.tsx">
      <Modal isOpen={isOpened} onClose={handleClose} size="xs" isCentered data-sentry-element="Modal" data-sentry-source-file="index.tsx">
        <ModalOverlay data-sentry-element="ModalOverlay" data-sentry-source-file="index.tsx" />
        <ModalContent maxW="31.25rem" w="full" h="21.875rem" bg="background.alwaysDark" p="2xl" borderRadius="xs" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
          <Button aria-label="button-close-modal-unauthenticated" variant="naked" color="content.alwaysLight" onClick={handleClose} position="absolute" top="4xl" right="3xl" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Close w="16" h="16" color="content.alwaysLight" data-sentry-element="Close" data-sentry-source-file="index.tsx" />
          </Button>

          <Flex direction="column" maxW="31.25rem" w="full" h="full" gap="xl" bg="background.alwaysDark" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <ModalHeader bg="background.alwaysDark" data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
              <Thumb src="/assets/eqi-logo.svg" width={40} height={40} data-sentry-element="Thumb" data-sentry-source-file="index.tsx" />
            </ModalHeader>

            <ModalBody w="full" data-sentry-element="ModalBody" data-sentry-source-file="index.tsx">
              <Flex direction="column" gap="2xl" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
                <Text size="md" color="content.alwaysLight" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                  {t(`modalUnauthenticated.title`)}
                </Text>
                <Flex flexDir="column" w="full" gap="l" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
                  <Flex aria-label="button-login-modal-unauthenticated" as={Link} href={`${PATHS.auth.login}?href=${window.location.pathname}`} target="_blank" justifyContent="center" alignItems="center" h="2.75rem" fontSize="sm" bgColor="content.brand" borderRadius="xs" transition="background-color 0.2s" _hover={{
                  bg: 'action.hover.brand'
                }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
                    <Text size="l" color="content.alwaysLight" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                      {t(`modalUnauthenticated.loginButton`)}
                    </Text>
                  </Flex>

                  <Text size="xs" color="content.alwaysLight" textAlign="center" fontWeight="light" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                    {t(`modalUnauthenticated.registerQuestion`)}

                    <Text aria-label="button-register-modal-unauthenticated" size="2xs" as={Link} href={`${PATHS.auth.register}?href=${window.location.pathname}`} target="_blank" color="content.alwaysLight" fontWeight="normal" ml="2xs" data-sentry-element="Text" data-sentry-source-file="index.tsx">
                      {t(`modalUnauthenticated.clickHere`)}
                    </Text>
                  </Text>
                </Flex>
              </Flex>
            </ModalBody>
          </Flex>
        </ModalContent>
      </Modal>
    </Portal>;
};